'use client';

import React, { FC } from 'react';
import { Row, Col, CardDeck, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import classnames from 'classnames';
import Link from 'next/link';
import styles from './SingleItem.module.scss';
import TruncateMarkup from 'react-truncate-markup';
import parse from 'html-react-parser';

//import components
import GridImages from '@/components/GridImages/GridImages';

//Import Libs
import { ParamsProps } from '@/libs/interfaceProps/paramsProps';
import { orgPath } from '@/libs/orgPath/orgPath';
import { sanitizeTitle } from '@/libs/sanitizeTitle/sanitizeTitle';

// Context
import { useResourceContext } from '@/context/resourceContext';
import { useTranslations } from 'next-intl';
import useResFallbackImages from '@/libs/resFallbackImages/resFallbackImages';
import { sitenameImageIndexHandler } from '@/libs/sitenameImageIndexHandler/sitenameImageIndexHandler';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
interface SingleItemProps {
  sectionHeadingTitle: string;
  params: ParamsProps;
  queryParams: string;
}
const SingleItem: FC<SingleItemProps> = ({
  sectionHeadingTitle,
  params,
  queryParams
}) => {
  const {
    resource
  } = useResourceContext();
  const t = useTranslations('Fulfillment');
  const fallbackImages = useResFallbackImages();
  const sitenameImageIndex: Record<string, number> = {};
  return <>
   {sectionHeadingTitle && <Row className={'gx-'}>
     <h2 className={'section-heading'} data-bdd={'section-heading_download-next'}>
      {sectionHeadingTitle}
     </h2>
    </Row>}

   <Row className={classnames(styles['singleitem-row'], 'banner-singlecard')} data-bdd="singleitem-row" data-sentry-element="Row" data-sentry-source-file="SingleItem.tsx">
    <CardDeck data-sentry-element="CardDeck" data-sentry-source-file="SingleItem.tsx">
     <Card className={'singleitem-card'} data-sentry-element="Card" data-sentry-source-file="SingleItem.tsx">
      <Col sm="12" md="3" lg="3" data-sentry-element="Col" data-sentry-source-file="SingleItem.tsx">
       <div className={classnames('grid-image-wrap', 'faux-letterbox')}>
        <GridImages GridType={'singlegrid'} resId={resource?.resId} primarySiteName={resource?.primarySiteName} fallbackimage={sitenameImageIndexHandler(sitenameImageIndex, fallbackImages, resource?.primarySiteName ? resource?.primarySiteName : 'genericMulti', resource?.resId)} data-sentry-element="GridImages" data-sentry-source-file="SingleItem.tsx" />
       </div>
      </Col>

      <Col sm="12" md="9" lg="9" data-sentry-element="Col" data-sentry-source-file="SingleItem.tsx">
       <CardBody className={'card-body'} data-sentry-element="CardBody" data-sentry-source-file="SingleItem.tsx">
        <CardTitle className={'asset-title'} data-sentry-element="CardTitle" data-sentry-source-file="SingleItem.tsx">
         {parse(sanitizeTitle(resource?.bestTitle))}
        </CardTitle>

        {/*  Trucate module expects a strict string passed, only display if var is string and has length */}
        {typeof resource?.shortDescription === 'string' && resource?.shortDescription.length > 0 && <TruncateMarkup lines={2} tokenize={'words'}>
           <div className={'asset-descrip'}>
            {parse(sanitizeTitle(resource?.shortDescription))}
           </div>
          </TruncateMarkup>}

        <CardFooter data-sentry-element="CardFooter" data-sentry-source-file="SingleItem.tsx">
         <p className={'view-more-client-link'}>
          <Link onClick={() => pushGTMClickTags({
                    click_element: 'Anchor',
                    click_closest_class: 'view-more-client-link',
                    click_section_ID: 'NONE',
                    link_classes: 'NONE',
                    link_id: 'NONE',
                    link_text: 'View more from',
                    link_url: `/${resource.orgId}`,
                    click_category: 'NONE',
                    click_destination: 'org page',
                    click_closest_href: 'NONE'
                  })} prefetch={false} href={orgPath({
                    orgId: resource.orgId,
                    locale: params.lang,
                    c: false,
                    peId: ''
                  }) + queryParams} data-sentry-element="Link" data-sentry-source-file="SingleItem.tsx">
           {t.rich('ViewMoreFrom', {
                      orgName: () => <span className={'client-name'}>
              {parse(sanitizeTitle(resource?.orgName))}
             </span>
                    })}
          </Link>
         </p>
        </CardFooter>
       </CardBody>
      </Col>
     </Card>
    </CardDeck>
   </Row>
  </>;
};
export default SingleItem;